export default {
  FLAGS: '@create/flags',
  OVERVIEW_SHOWS_SORTING: '@create/dashboard-shows-sorting',
  HEADLINER_TOS: '@create/headliner-tos',
};
